<template>
    <footer class="limit">
        <div class="footer-col">
            <b>Wij Weten Dingen</b>
        </div>
        <div class="footer-col">
            <span>Parade 29, 5311 KL, 's-Hertogenbosch</span>
            <span>073 20 20 289</span>
            <span>iedereen@weetdingen.nl</span>

            <small>{{ $t('footer.contact_us') }}</small>
        </div>
        <div class="footer-col">
            <small>{{ $t('misc.part_of_wdd_group') }}</small>
            <small>
                <a href="https://wijdoendingen.nl">www.wijdoendingen.nl</a>
            </small>
        </div>
        <div class="footer-col">
            <small>
                <a href="#">{{ $t('footer.terms_and_conditions') }}</a>
            </small>
            <small>
                <a href="#">{{ $t('footer.disclaimer') }}</a>
            </small>
            <small>
                <a href="#">{{ $t('footer.cookies_and_privacy_statement') }}</a>
            </small>
            <small>&copy; Wij Weten Dingen, {{ year }}</small>
        </div>
    </footer>
</template>

<script>
export default {
    mounted() {},
    computed: {
        year() {
            return new Date().getFullYear();
        }
    },
    props: {},
    components: {}
};
</script>

<style scoped lang="scss">
footer {
    font-size: 14px;

    padding: 20px;
    padding-top: 40px;
    padding-bottom: 100px;

    display: grid;
    grid-template-columns: 1fr 2fr 2fr 1fr;

    @media screen and (max-width: 950px) {
        grid-template-columns: 1fr;
    }

    color: rgb(209, 209, 209);

    font-size: 0.8em;

    background-color: black;

    a {
        color: inherit;
    }

    .footer-col {
        display: flex;
        flex-direction: column;
    }

    span,
    small {
        margin-bottom: 10px;
    }

    small {
        margin-top: 10px;

        opacity: 0.7;

        &:nth-child(1) {
            margin-top: 0;
        }
    }
}
</style>
